import { NoticeExtractorLegalDataResponseDto, NoticeExtractorProcessResponseDto } from 'app/API';
import { AttachmentsCard } from '../AttachmentsCard';
import { CaseInformationCard } from '../CaseInformationCard';
import { DocumentDetailsCard } from '../DocumentDetailsCard';
import { EventsCard } from '../EventsCard';
import { FieldSourcesCard } from '../FieldSourcesCard';
import { KeytermsCard } from '../KeytermsCard';
import { LawFirmsCard } from '../LawFirmsCard';
import { PartiesCard } from '../PartiesCard';

type TProps = {
  result: NoticeExtractorProcessResponseDto;
  showKeyterms: boolean;
};

export function ResultView({ result, showKeyterms }: TProps) {
  const legalData: Partial<NoticeExtractorLegalDataResponseDto> = result.legalData ?? {};

  return (
    <>
      <div className="mb-4 grid grid-cols-3 gap-2.5 max-[860px]:grid-cols-1">
        <div className="min-w-0 rounded-[10px] border border-border bg-surface-muted p-3">
          <span className="block text-[11px] font-bold uppercase leading-[14px] text-foreground-muted">File</span>
          <span className="mt-1 block [overflow-wrap:anywhere] text-sm font-bold leading-5 text-foreground">
            {result.filename}
          </span>
        </div>
        <div className="min-w-0 rounded-[10px] border border-border bg-surface-muted p-3">
          <span className="block text-[11px] font-bold uppercase leading-[14px] text-foreground-muted">Found</span>
          <span className="mt-1 block [overflow-wrap:anywhere] text-sm font-bold leading-5 text-foreground">
            {result.extractionSummary.found}/{result.extractionSummary.total}
          </span>
        </div>
        <div className="min-w-0 rounded-[10px] border border-border bg-surface-muted p-3">
          <span className="block text-[11px] font-bold uppercase leading-[14px] text-foreground-muted">Missing</span>
          <span className="mt-1 block [overflow-wrap:anywhere] text-sm font-bold leading-5 text-foreground">
            {result.extractionSummary.missingFields.length}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3.5 max-[860px]:grid-cols-1">
        <CaseInformationCard data={legalData.case_information} />
        <DocumentDetailsCard data={legalData.document_details} />
        <PartiesCard parties={legalData.parties} />
        <LawFirmsCard lawFirms={legalData.law_firms} />
        <EventsCard events={legalData.scheduled_events} />
        <AttachmentsCard attachments={legalData.attachments} />
        {showKeyterms ? <KeytermsCard keyterms={result.keyterms} /> : null}
        <FieldSourcesCard sources={result.fieldSources} />
      </div>

      <pre className="mt-3.5 max-h-[360px] overflow-auto whitespace-pre-wrap rounded-[10px] border border-border bg-surface-muted p-3 text-xs leading-[18px] text-foreground">
        {JSON.stringify(result, null, 2)}
      </pre>
    </>
  );
}
